import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

type userContactSupportEventArgs = {
  helpCenterSessionId: string | null
  oldThreadId?: string | null
  newThreadId?: string | null
}

type userContactSupportEventExtraArgs = {
  old_thread_id?: string
  help_center_session_id: string | null
  new_thread_id?: string
}

export const userContactSupportEvent = (args: userContactSupportEventArgs): TrackingEvent => {
  const { helpCenterSessionId } = args

  const extra: userContactSupportEventExtraArgs = {
    help_center_session_id: helpCenterSessionId,
  }

  if (args.newThreadId) {
    extra.new_thread_id = args.newThreadId
  }

  if (args.oldThreadId) {
    extra.old_thread_id = args.oldThreadId
  }

  return {
    event: 'user.contact_support',
    extra,
  }
}

type NoticesUserEventArgs = {
  threadId: string
}

type NoticesUserEventExtra = {
  thread_id: string
}

export const noticesUserOpenFaq = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.open_faq',
    extra,
  }
}

export const noticesUserOpenContactForm = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.open_contact_form',
    extra,
  }
}

export const noticesUserSubmitTicket = (args: NoticesUserEventArgs) => {
  const extra: NoticesUserEventExtra = {
    thread_id: args.threadId,
  }

  return {
    event: 'notices.user.submit_ticket',
    extra,
  }
}
